import { Form } from "antd"
import React from "react"
import { TextInput } from "../../../../../components/Input/TextInput.tsx"

interface InitialSignatureBlockProps {
  fieldKey: string
  initialValue?: string
}

export function InitialSignatureBlock({
  fieldKey,
  initialValue
}: InitialSignatureBlockProps) {
  return (
    <>
      <Form.Item
        name={["block_data", fieldKey, "signer_label"]}
        label="Signature Label"
        initialValue={initialValue}
      >
        <TextInput placeholder="e.g. Client Signature" />
      </Form.Item>
    </>
  )
}
